import { render, staticRenderFns } from "./PeriodsFilter.vue?vue&type=template&id=09e9afa5&scoped=true&"
import script from "./PeriodsFilter.vue?vue&type=script&lang=ts&"
export * from "./PeriodsFilter.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "09e9afa5",
  null
  
)

export default component.exports